<button 
    [disabled]="this.isCopied || !this.textToCopy"
    type="button" 
    (click)="copy()" 
    #copyButton
    [style.fontSize.px]="iconSize" 
    class="copy-btn btn-light"
    data-bs-toggle="tooltip">
    <fa-icon 
        [icon]="isCopied ? faCheck : faCopy" 
        [ngStyle]="{'color': isCopied ? 'green' : 'gray'}">
    </fa-icon>
</button>
